export default __webpack_public_path__ + "images/b491287b7806d083bd7081df75a8c6e0.png";